import { DataSourcesContext } from '@qfa/forms';
import { PropsWithChildren } from 'react';
import { useDataSources } from './useDataSources';

type DataSourceProviderProps = PropsWithChildren<{
  integrations?: string[];
  /** used to power data source variables */
  values?: any;
}>;
export const DataSourceProvider = ({
  children,
  integrations = [],
  values,
}: DataSourceProviderProps) => {
  const contextValue = useDataSources({ integrations, values });
  return <DataSourcesContext.Provider value={contextValue}>{children}</DataSourcesContext.Provider>;
};
